import { FilterableColumnsState } from "../../../components/common/filter/GridDataFilter";
import {
  GeofenceRequest,
  RtsRequest,
} from "../../models/requestModels/rtsRequest";
import { axiosRequests } from "../axiosRequest";

export const AddRtsAgent = {
  addRts: (rtsRequest: RtsRequest) =>
    axiosRequests.post<any>("/fdc-commandops/rts/bulk/add", rtsRequest),

  checkGeofence: (geofenceReq: GeofenceRequest) =>
    axiosRequests.post<any>("/fdc-commandops/rts/check/geofence", geofenceReq),

  uploadImage: (postData: any) =>
    axiosRequests.post<any>(
      "/fdc/image/internal/upload-binary-data?purpose=rts",
      postData
    ),

  exportCsvData: (
    clientId: number,
    startDate: string,
    endDate: string,
    filters: FilterableColumnsState,
    ids?: number[] | undefined
  ) =>
    axiosRequests.post<any>(
      "/fdc-commandops/rts/export-to-csv",
      {
        clientId: clientId,
        startDate: startDate,
        endDate: endDate,
        filters: filters,
        ids: ids,
      },
      {
        responseType: "blob",
      }
    ),
};
